import { measurementReady } from "./measurement";
import { useEffect, useSyncExternalStore } from 'react';
import { getConsentStatus, subscribeConsent } from './consent';
export const useConsentStatus = () => useSyncExternalStore(subscribeConsent, getConsentStatus, () => 'unknown');
export function ConsentChoices() {
  useEffect(measurementReady, []);
  return null;
}
